/* app/js/src/components/graphics/edit/fields/text-dynamic-options.component.scss */
.cursor-pointer {
  cursor: pointer;
}
.btn-add {
  display: inline-block;
  color: #ffffff;
  border-radius: 4px;
  background-color: #232f3a;
  padding: 6px 9px 6px 9px;
  font-size: 0.85em;
  border: 1px solid #879baf;
  cursor: pointer;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.btn-add:focus {
  outline-color: #ffffff;
}
.btn-add:hover {
  background-color: white;
  color: #232f3a;
}
.disabled.btn-add {
  color: #879baf;
  background-color: #dde3e7;
  border-color: #dde3e7;
  cursor: auto;
}
* {
  box-sizing: border-box;
}
.dynamic-options-container {
  display: flex;
  flex-direction: row;
}
.dynamic-options-dropdown,
.dynamic-options-tag-dropdown,
.dynamic-options-timezone-dropdown,
.dynamic-options-day-of-week-dropdown,
.dynamic-options-metadata-dropdown {
  max-width: 200px;
  margin-left: 15px;
}
.btn-add {
  margin-left: 15px;
  width: 42px;
}
/*# sourceMappingURL=text-dynamic-options.component.css.map */
